import { Component, Input } from '@angular/core'
import { Router } from '@angular/router'
import { SemanticPathService } from '@spartacus/core'

@Component({
  selector: 'mb-myaccount-button',
  templateUrl: './mb-myaccount-button.component.html',
  styleUrls: ['./mb-myaccount-button.component.scss']
})
export class MbMyaccountButtonComponent {

  @Input() path = ''
  @Input() textTranslationPath = ''

  constructor (protected router: Router, protected semanticPathService: SemanticPathService) {
  }
  executeClick () {
    return this.router.navigate([this.semanticPathService.get(this.path)])
  }
}
